define('responsive-gameday-footer/src/js/LaunchGameday',['require','exports','module','client/client','bam.url/url'],function(require, module, exports) {
    var client = require("client/client");
    var Url = require("bam.url/url");
    var popWin = function(url,n,w,h,o) {
	  if (w>screen.availWidth-12) w=screen.availWidth-12;
	  if (h>screen.availHeight-48) h=screen.availHeight-48;
	  _pw_l=(screen.availWidth-w-12)/2;
	  _pw_t=(screen.availHeight-h-48)/2;
	  _pw_z=window.open(url,n,'width='+w+',height='+h+',left='+_pw_l+',top='+_pw_t+','+o);
     }


    function launchGameday(params) {
        if (client.isIPad && (!params.mode || (params.mode === "gameday" || params.mode === "atbat"))) {
            window.location.href = '/mobile/ipad/index.jsp?affiliateId=launchGameday';
            return;
        }

        var baseURL,
            winName = "GamedayWin",
            isv4 = false,
            isMLBgame = false,
            isWBCgame = false,
            thisWinName = window.name,

            parentIsMini = thisWinName.indexOf('gdmini_') !== -1,
            parentIsGD = thisWinName.indexOf('gd_') != -1,

            onGamedayPage = window.section === "gameday";


        baseURL = (function(domain) {
            if (domain.indexOf('dev-') !== -1) {
                return 'http://' + document.domain;
            } else if (domain.indexOf('qa') !== -1) {
                return "http://qa2.mlb.com";
            } else if (domain.indexOf('beta') != -1) {
                return "http://beta.mlb.com";
            } else {
                return "http://mlb.mlb.com";
            }
        })(document.domain);

        /**
         * @desc  objectify string parameters
         */
        var objectifyParams = function(params) {
            var kvp = params.replace(/^\?/i, '').split('&');
            var rParams = {};
            if (kvp instanceof Array) {
                kvp.reverse();
                var vpl = kvp.length - 1;
                var vp, op;
                do {
                    vp = kvp[vpl].split('=');
                    switch (true) {
                        case ((rParams[vp[0]] != null) && !(rParams[vp[0]] instanceof Array)):
                            op = rParams[vp[0]];
                            rParams[vp[0]] = [op, vp[1]];
                            break;
                        case (rParams[vp[0]] instanceof Array):
                            rParams[vp[0]].push(vp[1]);
                            break;
                        case (vp[0].length === 26):
                            rParams['gid'] = vp[0];
                            break;
                        default:
                            rParams[vp[0]] = vp[1];
                    }
                } while (vpl--);
                kvp = null;
            }

            return rParams;
        }

        params = (typeof params !== 'object') ? objectifyParams(params) : params;


        var gid = params.gid || "",
            mode = params.mode || "",
            c_id = params.c_id || "",
            lang = params.lang || "",
            lurl = params.lurl || "#",
            env = params.env || Url.Location(window.location).getParam("env") || "",
            feed_code = params.feed_code || null,
            media_state = params.media_state || null,
            sport_code = gid.substring(21, 24);

        if (sport_code === "mlb" || sport_code === "min" || sport_code === "int" || sport_code === "win") {
            isMLBgame = true;
        }

        var config = {
            "2005": {
                url: '/mlb/gameday/gd2005.html?' + gid + (env !== '' ? '&env=' + env : ''),
                winOpts: 'location=no,menubar=no,scrollbars=no,status=no,toolbar=no,resizable=yes',
                w: 770,
                h: 600
            },

            "2006": {
                url: '/mlb/gameday/y2006/gd.html?' + gid + (env !== '' ? '&env=' + env : ''),
                winOpts: 'location=no,menubar=no,scrollbars=no,status=no,toolbar=no,resizable=yes',
                w: 770,
                h: 600
            },

            "2007": {
                url: '/mlb/gameday/y2007/gd.html?' + gid + (env !== '' ? '&env=' + env : ''),
                winOpts: 'location=no,menubar=no,scrollbars=no,status=no,toolbar=no,resizable=yes',
                w: 980,
                h: 600
            },

            // 2008, 2009
            "v4": {
                //isv4 : true,
                url: '/mlb/gameday/y2009/index.jsp?gid=' + gid + (mode !== '' ? '&mode=' + mode : '') + (env !== '' ? '&env=' + env : ''),
                winName: (!!parentIsMini) ? thisWinName : 'gdmini_' + gid,
                w: !parentIsMini ? window.innerWidth : 990,
                h: !parentIsMini ? window.innerHeight : 576
            },

            // 2008, 2009
            "v4_mini": {
                //isv4 : true,
                url: '/mlb/gameday/mini.jsp?gid=' + gid + (env !== '' ? '&env=' + env : ''),
                winName: 'gdmini_' + gid,
                winOpts: 'location=no,menubar=no,scrollbars=no,status=no,toolbar=no,resizable=yes',
                w: 300,
                h: 368
            },

            // 2013 World Baseball Classic
            "v6_wbc2013": {
                url: '/wbc/2013/gameday/index.jsp?gid=' + gid + (mode !== '' ? '&mode=' + mode : '') + (env !== '' ? '&env=' + env : '') + (lang !== '' ? '&lang=' + lang : ''),
                w: !parentIsMini ? window.innerWidth : 990,
                h: !parentIsMini ? window.innerHeight : 576
            },

            "v5": {
                url: '/mlb/gameday/index.jsp?gid=' + gid + (mode !== '' ? '&mode=' + mode : '') + (c_id !== '' ? '&c_id=' + c_id : '') + (env !== '' ? '&env=' + env : '') + (lang !== '' ? '&lang=' + lang : '') + (!!feed_code ? '&feed_code=' + feed_code : '') + (!!media_state ? '&media_state=' + media_state : ''),
                w: !parentIsMini ? window.innerWidth : 990,
                h: !parentIsMini ? window.innerHeight : 576
            }
        };

        var getGamedayLink = function(params) {
            var year = params.gid.substring(0, 4),
                sport_code = params.gid.substring(21, 24),
                version;

            // TODO: put this logic in config?

            if (mode === 'mini') {
                version = 'v4_mini';
                // 2013 World Baseball Classic
            } else if (((parseInt(year, 10) === 2012) || (parseInt(year, 10) === 2013)) && sport_code === 'int') {
                version = 'v6_wbc2013';
                // 2010 and forward use v5 aka penguin
            } else if (parseInt(year, 10) >= 2010) {
                version = 'v5';
                // 2008/09 use v4
            } else if (year.indexOf('2008') !== -1 || year.indexOf('2009') !== -1) {
                version = 'v4';
                // everything else uses year
            } else {
                version = year;
            }

            // console.log( 'config[ ', version, ' ] :', config[ version ] );

            return $.extend({
                "version": version
            }, config[version]);
        }

        var gamedayLinkObj = getGamedayLink(params);

        // version by year
        if (gamedayLinkObj.version.indexOf("v") === -1) {
            // handle legacy preview links
            if (mode === 'preview') {
                window.location.href = lurl;
                // pop legacy gameday
            } else {
                popWin(baseURL + gamedayLinkObj.url, winName, gamedayLinkObj.w, gamedayLinkObj.h, gamedayLinkObj.winOpts);
            }

            // version by number 
        } else {
            // mini
            if (mode === 'mini') {
                popWin(baseURL + gamedayLinkObj.url, gamedayLinkObj.winName, gamedayLinkObj.w, gamedayLinkObj.h, gamedayLinkObj.winOpts);

            } else if (mode === 'preview' && onGamedayPage) {
                window.location.href = lurl;

                // pop v4 gameday in new window
            } else if ("v4".indexOf(gamedayLinkObj.version) !== -1) {
                window.open(baseURL + gamedayLinkObj.url, 'gd_' + gid);

                // open 2013 World Baseball Classic in current window
            } else if ("v6_wbc2013".indexOf(gamedayLinkObj.version) !== -1) {
                if (parentIsMini) {
                    window.open(baseURL + gamedayLinkObj.url, 'gd_' + gid);
                } else {
                    window.location.href = baseURL + gamedayLinkObj.url;
                }

                // open v5 gameday in current window
            } else if ("v5".indexOf(gamedayLinkObj.version) !== -1) {
                if (parentIsMini || window.alwaysOpenGamedayInNewWindow) {
                    window.open(baseURL + gamedayLinkObj.url, 'gd_' + gid);
                } else {
                    window.location.href = baseURL + gamedayLinkObj.url;
                }

            }
        }




    }


    return launchGameday;
});
